module.exports = __webpack_public_path__ + "static/media/mxf.fbf1e6c6.svg";